import { render, staticRenderFns } from "./ModalMotivoBaja.vue?vue&type=template&id=53190db6"
import script from "./ModalMotivoBaja.vue?vue&type=script&lang=js"
export * from "./ModalMotivoBaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports